import { z } from 'zod'
import { SuccessEnvelope } from './common.js'
import { IdeaCard } from './idea.js'

export const DashboardResponse = SuccessEnvelope(
  z.object({
    full_name: z.string().nullable(),
    points: z.number(),
    rank: z.number().nullable(),
    rank_movement: z.number().nullable().optional(),
    rank_movement_label: z.string().nullable().optional(),
    /** ISO timestamp of the caller's most recent completed validation. */
    last_validated_at: z.union([z.string(), z.date()]).nullable().optional(),
    /** Distinct users (excluding self) who validated any of the caller's ideas. */
    community_validators: z.number().optional(),
    ideas_submitted: z.array(
      IdeaCard.extend({
        idea_rank: z.number().nullable().optional(),
        rank_movement: z.number().nullable().optional(),
        rank_movement_label: z.string().nullable().optional(),
      }),
    ),
    ideas_validated: z.array(IdeaCard),
    /**
     * Ideas the caller deleted. Deletion is a soft flag, so these are still
     * here and still restorable. Kept in their own array so no headline count
     * on the dashboard picks them up.
     */
    ideas_deleted: z.array(IdeaCard).optional(),
  }),
)

export const HomeResponse = SuccessEnvelope(
  z.object({
    total_ideas_submitted: z.number(),
    ideas_submitted_this_week: z.number(),
    total_validators: z.number(),
    top_ideas: z.array(IdeaCard),
  }),
)

export const LeaderboardResponse = SuccessEnvelope(
  z.object({
    stats: z.object({
      total_validators: z.number(),
      total_ideas_validated: z.number(),
      total_points_awarded: z.number(),
    }),
    my_rank: z.number().nullable(),
    my_rank_movement: z.number().nullable(),
    my_rank_movement_label: z.string().nullable(),
    my_ideas: z.array(z.unknown()),
    validators: z.array(z.unknown()),
    ideas: z.array(z.unknown()),
  }),
)

export const MyPointsResponse = SuccessEnvelope(
  z.array(
    z.object({
      id: z.string(),
      user_id: z.string(),
      points: z.number(),
      reason: z.string(),
      reference_id: z.string().nullable(),
      created_at: z.union([z.string(), z.date()]).nullable().optional(),
    }),
  ),
)
